module.exports = __webpack_public_path__ + "img/signin_icon__avatar_stu_normal.b90e01c6.png";